// Traduções do Início do portal — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'portal.portalHome.title': 'Início',
    'portal.portalHome.eyebrow': 'Portal do cliente',
    'portal.portalHome.greeting': 'Olá, {{name}}',
    'portal.portalHome.customerFallback': 'cliente',
    'portal.portalHome.subtitle': 'Acompanhe a sua operação: o que está programado, o que está na estrada e o que já chegou.',
    'portal.portalHome.requestLoads': 'Solicitar cargas',
    'portal.portalHome.loadError': 'Não foi possível carregar o painel',
    'portal.portalHome.kpiToday': 'Cargas hoje',
    'portal.portalHome.kpiTodayHint': 'programadas para hoje',
    'portal.portalHome.kpiInTransit': 'Em trânsito',
    'portal.portalHome.kpiInTransitHint': 'a caminho da unidade',
    'portal.portalHome.kpiDeliveredToday': 'Entregues hoje',
    'portal.portalHome.kpiDeliveredTodayHint': 'descarregadas e liberadas',
    'portal.portalHome.kpiInProgress': 'Em andamento',
    'portal.portalHome.kpiInProgressHint': 'iniciadas e ainda não concluídas',
    'portal.portalHome.kpiOpenRequests': 'Em aberto',
    'portal.portalHome.kpiOpenRequestsHint': 'solicitações enviadas, em análise ou em execução',
    'portal.portalHome.kpiNotServed': 'Não atendidas',
    'portal.portalHome.kpiNotServedHint': 'nos últimos 30 dias',
    'portal.portalHome.todayLoads': 'Cargas de hoje',
    'portal.portalHome.seeAllLoads': 'Ver todas',
    'portal.portalHome.noLoadsToday': 'Nenhuma carga programada para hoje.',
    'portal.portalHome.destination': 'Destino',
    'portal.portalHome.noTruck': 'Sem caminhão',
    'portal.portalHome.noDriver': 'Motorista a definir',
    'portal.portalHome.arrival': 'Chegada {{time}}',
    'portal.portalHome.loadsByStage': 'Andamento das cargas',
    'portal.portalHome.loads': 'cargas',
    'portal.portalHome.loadsPerDay': 'Cargas por dia',
    'portal.portalHome.loadsPerDayHint': 'Duas semanas para trás e uma para a frente. Hoje em destaque.',
    'portal.portalHome.scheduled': 'Programadas',
    'portal.portalHome.delivered': 'Entregues',
    'portal.portalHome.noLoadsInWindow': 'Sem cargas no período.',
    'portal.portalHome.fronts': 'Frentes em andamento',
    'portal.portalHome.seeAllContracts': 'Ver contratos',
    'portal.portalHome.noFronts': 'Nenhuma frente ativa no momento.',
    'portal.portalHome.contractNumber': 'Contrato {{number}}',
    'portal.portalHome.progressOf': 'Progresso do contrato {{number}}',
    'portal.portalHome.loadsDone': '{{done}} de {{total}} cargas',
    'portal.portalHome.loadsInProgressCount': '{{count}} em andamento',
    'portal.portalHome.loadsNotServedCount': '{{count}} não atendidas',
    'portal.portalHome.nextDeliveries': 'Próximas entregas',
    'portal.portalHome.noScheduledLoads': 'Nenhuma carga programada para os próximos dias.',
    'portal.portalHome.ticketsByStatus': 'Solicitações por situação',
    'portal.portalHome.tickets': 'solicitações',
    'portal.portalHome.seeRequests': 'Ver todas',
  },
  en: {
    'portal.portalHome.title': 'Home',
    'portal.portalHome.eyebrow': 'Customer portal',
    'portal.portalHome.greeting': 'Hello, {{name}}',
    'portal.portalHome.customerFallback': 'customer',
    'portal.portalHome.subtitle': 'Follow your operation: what is scheduled, what is on the road and what has arrived.',
    'portal.portalHome.requestLoads': 'Request loads',
    'portal.portalHome.loadError': 'The dashboard could not be loaded',
    'portal.portalHome.kpiToday': 'Loads today',
    'portal.portalHome.kpiTodayHint': 'scheduled for today',
    'portal.portalHome.kpiInTransit': 'In transit',
    'portal.portalHome.kpiInTransitHint': 'on the way to the unit',
    'portal.portalHome.kpiDeliveredToday': 'Delivered today',
    'portal.portalHome.kpiDeliveredTodayHint': 'unloaded and released',
    'portal.portalHome.kpiInProgress': 'In progress',
    'portal.portalHome.kpiInProgressHint': 'started and not yet completed',
    'portal.portalHome.kpiOpenRequests': 'Open',
    'portal.portalHome.kpiOpenRequestsHint': 'requests submitted, under review or in progress',
    'portal.portalHome.kpiNotServed': 'Not served',
    'portal.portalHome.kpiNotServedHint': 'in the last 30 days',
    'portal.portalHome.todayLoads': "Today's loads",
    'portal.portalHome.seeAllLoads': 'See all',
    'portal.portalHome.noLoadsToday': 'No loads scheduled for today.',
    'portal.portalHome.destination': 'Destination',
    'portal.portalHome.noTruck': 'No truck',
    'portal.portalHome.noDriver': 'Driver to be assigned',
    'portal.portalHome.arrival': 'Arrival {{time}}',
    'portal.portalHome.loadsByStage': 'Loads by stage',
    'portal.portalHome.loads': 'loads',
    'portal.portalHome.loadsPerDay': 'Loads per day',
    'portal.portalHome.loadsPerDayHint': 'Two weeks back and one week ahead. Today is highlighted.',
    'portal.portalHome.scheduled': 'Scheduled',
    'portal.portalHome.delivered': 'Delivered',
    'portal.portalHome.noLoadsInWindow': 'No loads in this period.',
    'portal.portalHome.fronts': 'Active fronts',
    'portal.portalHome.seeAllContracts': 'See contracts',
    'portal.portalHome.noFronts': 'No active front at the moment.',
    'portal.portalHome.contractNumber': 'Contract {{number}}',
    'portal.portalHome.progressOf': 'Progress of contract {{number}}',
    'portal.portalHome.loadsDone': '{{done}} of {{total}} loads',
    'portal.portalHome.loadsInProgressCount': '{{count}} in progress',
    'portal.portalHome.loadsNotServedCount': '{{count}} not served',
    'portal.portalHome.nextDeliveries': 'Upcoming deliveries',
    'portal.portalHome.noScheduledLoads': 'No loads scheduled for the coming days.',
    'portal.portalHome.ticketsByStatus': 'Requests by status',
    'portal.portalHome.tickets': 'requests',
    'portal.portalHome.seeRequests': 'See all',
  },
  es: {
    'portal.portalHome.title': 'Inicio',
    'portal.portalHome.eyebrow': 'Portal del cliente',
    'portal.portalHome.greeting': 'Hola, {{name}}',
    'portal.portalHome.customerFallback': 'cliente',
    'portal.portalHome.subtitle': 'Siga su operación: lo programado, lo que está en camino y lo que ya llegó.',
    'portal.portalHome.requestLoads': 'Solicitar cargas',
    'portal.portalHome.loadError': 'No fue posible cargar el panel',
    'portal.portalHome.kpiToday': 'Cargas hoy',
    'portal.portalHome.kpiTodayHint': 'programadas para hoy',
    'portal.portalHome.kpiInTransit': 'En tránsito',
    'portal.portalHome.kpiInTransitHint': 'en camino a la unidad',
    'portal.portalHome.kpiDeliveredToday': 'Entregadas hoy',
    'portal.portalHome.kpiDeliveredTodayHint': 'descargadas y liberadas',
    'portal.portalHome.kpiInProgress': 'En curso',
    'portal.portalHome.kpiInProgressHint': 'iniciadas y aún no concluidas',
    'portal.portalHome.kpiOpenRequests': 'Abiertas',
    'portal.portalHome.kpiOpenRequestsHint': 'solicitudes enviadas, en análisis o en ejecución',
    'portal.portalHome.kpiNotServed': 'No atendidas',
    'portal.portalHome.kpiNotServedHint': 'en los últimos 30 días',
    'portal.portalHome.todayLoads': 'Cargas de hoy',
    'portal.portalHome.seeAllLoads': 'Ver todas',
    'portal.portalHome.noLoadsToday': 'Ninguna carga programada para hoy.',
    'portal.portalHome.destination': 'Destino',
    'portal.portalHome.noTruck': 'Sin camión',
    'portal.portalHome.noDriver': 'Conductor por definir',
    'portal.portalHome.arrival': 'Llegada {{time}}',
    'portal.portalHome.loadsByStage': 'Avance de las cargas',
    'portal.portalHome.loads': 'cargas',
    'portal.portalHome.loadsPerDay': 'Cargas por día',
    'portal.portalHome.loadsPerDayHint': 'Dos semanas hacia atrás y una hacia adelante. Hoy destacado.',
    'portal.portalHome.scheduled': 'Programadas',
    'portal.portalHome.delivered': 'Entregadas',
    'portal.portalHome.noLoadsInWindow': 'Sin cargas en el período.',
    'portal.portalHome.fronts': 'Frentes en curso',
    'portal.portalHome.seeAllContracts': 'Ver contratos',
    'portal.portalHome.noFronts': 'Ningún frente activo en este momento.',
    'portal.portalHome.contractNumber': 'Contrato {{number}}',
    'portal.portalHome.progressOf': 'Avance del contrato {{number}}',
    'portal.portalHome.loadsDone': '{{done}} de {{total}} cargas',
    'portal.portalHome.loadsInProgressCount': '{{count}} en curso',
    'portal.portalHome.loadsNotServedCount': '{{count}} no atendidas',
    'portal.portalHome.nextDeliveries': 'Próximas entregas',
    'portal.portalHome.noScheduledLoads': 'Ninguna carga programada para los próximos días.',
    'portal.portalHome.ticketsByStatus': 'Solicitudes por situación',
    'portal.portalHome.tickets': 'solicitudes',
    'portal.portalHome.seeRequests': 'Ver todas',
  },
}
